<template>
  <div class="main-content">
    <div class="subtitle margin-top-16">
      {{ $t('message["1671"]') }}
    </div>
    <date-select
      ref="indexOverviewDate"
      class="margin-bottom-40 margin-top-16"
      :content-title="contentTitle"
      :date-data="dateData"
      :default-select-index="defaultSelectIndex"
      @callbackEvent="handleCallbackEvent"
      @dateTimeChange="handleDateChangeOverView"
    />
    <div class="margin-bottom-40">
      <div class="overview-main-index-parent">
        <div class="overview-main-div-children">
          <div
            v-for="(itemFrom,indexFrom) in fromDataArray"
            :key="indexFrom"
            class="item-from"
          >
            <span class="line-paste" />
            <span class="row-paste" />
            <p>{{ itemFrom.name }}（{{ itemFrom.per }}）</p>
            <p>{{ itemFrom.num }}</p>
          </div>
        </div>
        <div class="overview-main-div-children message-input-content">
          <span class="line-paste-message-left" />
          <span class="line-paste-message-right" />
          <P class="message-input-content-title-p">
            {{ totalInfo.name }}
          </P>
          <p class="message-input-content-value-p">
            {{ totalInfo.num }}
          </p>
        </div>
        <div class="overview-main-div-children">
          <div
            v-for="(itemStatus,statusIndex) in statusDataArray"
            :key="statusIndex"
            class="item-status"
          >
            <span
              v-if="itemStatus.name===passTit"
              class="line-paste-right"
            />
            <span class="line-paste-left" />
            <span class="row-paste-left" />
            <p>{{ itemStatus.name }}（{{ itemStatus.per }}）</p>
            <p :class="{fontColor6a9:itemStatus.name===reviewTit}">
              {{ itemStatus.num }}
            </p>
          </div>
        </div>
        <div class="overview-main-div-children">
          <div
            v-for="(item,index) in otherDataArray"
            :key="index"
            class="items-from"
          >
            <span class="line-paste-left" />
            <span class="row-paste-left" />
            <p>{{ item.name }}（{{ item.per }}）</p>
            <p :class="{fontColor27e:item.name===orderTxt,fontColor676:item.name===LostOrderTit}">
              {{ item.num }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div>
      <date-select
        ref="indexTableDetails"
        :content-title="dataContentTitle"
        :date-data="dataTableDate"
        :default-select-index="defaultDataTablendex"
        :filter-status="filterStatus"
        :export-status="exportStatus"
        :export-params="exportParams"
        @callbackEvent="handleCallbackTableEvent"
        @dateTimeChange="handleDateChangeTableDatas"
      />
      <div class="table-data-div margin-top-24 margin-bottom-40">
        <a-table
          :columns="tableColumns"
          :data-source="tableData"
          align="right"
          :pagination="false"
          row-key="sortId"
          @change="handleTableChange"
        >
          <template
            slot="infotype"
            slot-scope="text"
          >
            <a-popover>
              <template slot="content">
                <p>{{ text }}</p>
              </template>
              <span
                class="infotype textOverflow"
              >{{ text }}</span>
            </a-popover>
          </template>
          <template
            slot="infofrom"
            slot-scope="infofrom"
          >
            <span>{{ infofrom.name }}</span>
            <a-popover v-if="!infofrom.status">
              <template slot="content">
                <p>{{ $t('message["342"]') }}</p>
              </template>
              <i class="iconfont iconicon-test34 table-alert" />
            </a-popover>
          </template>
        </a-table>
        <Pagination
          v-if="tableData.length"
          :pagination="pagesData"
          @change="handlePageChange"
        />
      </div>
    </div>
    <check-dialog :time="detailTimeData" />
    <a-spin
      v-if="loadingContent"
      class="spin-css"
    />
  </div>
</template>
<script>
import DateSelect from './components/DateSelectComponent'
import Pagination from '@/components/pc/Pagination'
import CheckDialog from './components/CheckDialog'
import { overviewIndex } from '@/lib/statistic-utils.js'
import { mapState, mapActions, mapMutations } from 'vuex'
export default {
  components: {
    DateSelect,
    Pagination,
    CheckDialog
  },
  data () {
    return {
      exportParams: {},
      tableColumns: [],
      tableData: [],
      fromDataArray: [],
      tablecolumnsArray: [],
      statusDataArray: [],
      otherDataArray: [],
      overviewTimeData: { timetype: 1 },
      detailTimeData: { timetype: 1 },
      totalInfo: { name: '', num: null },
      filterStatus: true,
      exportStatus: true,
      contentTitle: this.$t('message["346"]'),
      defaultSelectIndex: 4,
      dateData: overviewIndex,
      dataContentTitle: this.$t('message["1130"]'),
      defaultDataTablendex: 4,
      dataTableDate: overviewIndex,
      pagesData: { total: 0, currentPage: 1, pageSize: 10, pageSizes: [10, 20, 30, 50] }
    }
  },
  computed: {
    ...mapState('statistic', ['indexHeadDatas', 'indexDetailDatas', 'loadingContent', 'checkParams']),
    orderTxt () {
      return this.$t('message["109"]')
    },
    reviewTit () {
      return this.$t('message["143"]')
    },
    passTit () {
      return this.$t('message["1206"]')
    },
    LostOrderTit () {
      return this.$t('message["1690"]')
    }
  },
  watch: {
    indexHeadDatas (val) {
      if (!val) {
        return
      }
      this.fromDataArray = val.from
      this.statusDataArray = val.status
      this.otherDataArray = val.other
      this.totalInfo = val.total
      document.title = `${this.$t('message["1671"]')}-${this.$store.state.baseinfo.projectname}-${this.$store.state.baseinfo.comname}`
    },
    indexDetailDatas (val) {
      if (!val) return
      this.pagesData.total = val.count
      this.pagesData.currentPage = val.currentPage
      this.pagesData.pageSize = val.curpagesize
      this.tableColumns = this.formateTableColmunsData(val.config)
      this.tableData = this.formateTableDatas(val.data)
    },
    checkParams (val) {
      if (!val) return
      this.exportParams = val
    }
  },
  mounted () {
    if (this.indexHeadDatas.from) {
      this.fromDataArray = this.indexHeadDatas.from
      this.statusDataArray = this.indexHeadDatas.status
      this.otherDataArray = this.indexHeadDatas.other
      this.totalInfo = this.indexHeadDatas.total
    }
    this.setLoadingContent(true)
    this.fetchGetIndexHeadDatas(this.overviewTimeData)
    this.fetchGetIndexDetailDatas({ ...this.detailTimeData, page: 1 })
    this.fetchGetIndexFilterDatas()
  },
  methods: {
    ...mapMutations('statistic', ['setLoadingContent']),
    ...mapActions('statistic', ['fetchGetIndexHeadDatas', 'fetchGetIndexDetailDatas', 'fetchGetIndexFilterDatas']),
    handleCallbackEvent (data) {
      delete this.overviewTimeData.starttime
      delete this.overviewTimeData.endtime
      this.overviewTimeData.timetype = data.key
      this.fetchGetIndexHeadDatas(this.overviewTimeData)
    },
    handlePageChange (val) {
      this.detailTimeData.pagesize = val.pageSize
      this.detailTimeData.page = val.currentPage
      this.fetchGetIndexDetailDatas({ ...this.detailTimeData })
    },
    handleCallbackTableEvent (data) {
      delete this.detailTimeData.starttime
      delete this.detailTimeData.endtime
      this.detailTimeData.timetype = data.key
      if (this.checkParams) {
        this.detailTimeData.info_type = this.checkParams.info_type
        this.detailTimeData.from_info = this.checkParams.from_info
      } else {
        delete this.detailTimeData.info_type
        delete this.detailTimeData.from_info
      }
      this.exportParams = this.detailTimeData
      this.fetchGetIndexDetailDatas(this.detailTimeData)
    },
    handleTableChange (pagination, filters, sorter) {
      const pager = { ...this.pagination }
      pager.current = pagination.current
      this.pagination = pager
      let sort = (sorter.order === 'ascend' ? 1 : 2)
      this.detailTimeData.sorttype = sort
      this.detailTimeData.sortId = sorter.field
      this.fetchGetIndexDetailDatas({ ...this.detailTimeData })
    },
    handleDateChangeOverView (value) {
      if (Array.isArray(value)) {
        if (value[0]) {
          this.$refs.indexOverviewDate.initdDteSelectIndex()
          this.overviewTimeData.starttime = value[0]
          this.overviewTimeData.endtime = value[1]
          delete this.overviewTimeData.timetype
          this.fetchGetIndexHeadDatas(this.overviewTimeData)
        }
      }
    },
    handleDateChangeTableDatas (value) {
      if (Array.isArray(value)) {
        if (value[0]) {
          this.$refs.indexTableDetails.initdDteSelectIndex()
          this.detailTimeData.starttime = value[0]
          this.detailTimeData.endtime = value[1]
          delete this.detailTimeData.timetype
          this.exportParams = this.detailTimeData
          this.fetchGetIndexDetailDatas(this.detailTimeData)
        }
      }
    },
    formateTableColmunsData (array) {
      let tempArray = []
      this.tablecolumnsArray = []
      if (Array.isArray(array)) {
        array.map(value => {
          this.tablecolumnsArray.push(value.sortId)
          if (value.options) {
            this.tableConfigOptions = Object.values(value.options)
          }
          if (value.sortable) {
            if (value.sortId === 'rank') {
              tempArray.push({
                title: value.name,
                key: value.sortId,
                dataIndex: value.sortId,
                scopedSlots: { customRender: 'rank' },
                sorter: (a, b) => a[value.sortId] - b[value.sortId]
              })
            } else if (value.sortId === 'name') {
              tempArray.push({
                title: value.name,
                key: value.sortId,
                dataIndex: value.sortId,
                scopedSlots: { customRender: 'name' },
                sorter: (a, b) => a[value.name].length - b[value.name].length
              })
            } else if (value.sortId === 'infofrom') {
              tempArray.push({
                title: value.name,
                key: value.sortId,
                dataIndex: value.sortId,
                scopedSlots: { customRender: 'infofrom' },
                sorter: (a, b) => a[value.sortId] - b[value.sortId]
              })
            } else {
              tempArray.push({
                title: value.name,
                key: value.sortId,
                dataIndex: value.sortId,
                scopedSlots: { customRender: value.sortId },
                sorter: (a, b) => a[value.sortId] - b[value.sortId]
              })
            }
          } else {
            if (value.sortId === 'rank') {
              tempArray.push({
                title: value.name,
                key: value.sortId,
                dataIndex: value.sortId,
                scopedSlots: { customRender: 'rank' }
              })
            } else if (value.sortId === 'name') {
              tempArray.push({
                title: value.name,
                key: value.sortId,
                dataIndex: value.sortId,
                scopedSlots: { customRender: 'name' }
              })
            } else if (value.sortId === 'infofrom') {
              tempArray.push({
                title: value.name,
                key: value.sortId,
                dataIndex: value.sortId,
                scopedSlots: { customRender: 'infofrom' }
              })
            } else {
              tempArray.push({
                title: value.name,
                key: value.sortId,
                dataIndex: value.sortId
              })
            }
          }
        })
      }
      return tempArray
    },
    formateTableDatas (array, flag) {
      let tempArray = []
      if (Array.isArray(array)) {
        array.map((value, indexs) => {
          let json = {}
          value.map((values, index) => {
            json.key = Math.random().toString()
            if (flag) {
              if (index === 0) {
                if (indexs === 0) {
                  json[this.tablecolumnsArray[index]] = this.$t('message["177"]')
                } else {
                  json[this.tablecolumnsArray[index]] = this.$t('message["910"]')
                }
                json[this.tablecolumnsArray[index + 1]] = values
              } else {
                json[this.tablecolumnsArray[index + 1]] = values
              }
            } else {
              json[this.tablecolumnsArray[index]] = values
            }
          })
          tempArray.push(json)
        })
      }
      return tempArray
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/css/statistic/style.scss';
.spin-css {
  position: absolute;
  top: 50%;
  left: 50%;
}
.table-alert {
  color: gray;
  margin-left: 4px;
  vertical-align: middle;
  cursor: pointer;
}
.overview-main-index-parent {
  display: table;
  width: 100%;
  margin: 0 auto;
  .line-paste {
    width: 19px;
    border-top: solid 1px #f1f1f1;
    position: relative;
    float: right;
    margin-right: -19px;
    margin-top: 30px;
  }
  .message-input-content {
    width: 230px;
    border-radius: 8px;
    background-color: #f5f8fb;
  }
  .overview-main-div-children {
    display: table-cell;
    vertical-align: middle;
    .line-paste-message-left {
      width: 22px;
      border-top: solid 1px #f1f1f1;
      position: relative;
      float: left;
      margin-left: -22px;
      margin-top: 14.8%;
    }
    .line-paste-message-right {
      width: 22px;
      border-top: solid 1px #f1f1f1;
      position: relative;
      float: right;
      margin-right: -22px;
      margin-top: 14.8%;
    }
    .item-status {
      width: 230px;
      height: 88px;
      border-radius: 8px;
      margin-left: 40px;
      background-color: #e8faf1;
      margin-bottom: 16px;
      padding-top: 16px;
      &:first-child {
        background-color: #f5f8fb;
      }
      &:last-child {
        background-color: #f5f8fb;
        margin-bottom: 0px;
        .row-paste-left {
          height: 0px;
        }
      }
      p {
        margin-left: 32px;
        &:first-child {
          height: 24px;
          font-size: 14px;
          font-weight: 600;
          font-style: normal;
          font-stretch: normal;
          line-height: 24px;
          letter-spacing: normal;
          color: #666666;
        }
        &:last-child {
          height: 40px;
          margin-top: 8px;
          font-size: 40px;
          font-weight: bold;
          font-style: normal;
          font-stretch: normal;
          line-height: 40px;
          letter-spacing: normal;
          color: #333333;
        }
      }
    }
    .message-input-content-title-p {
      height: 24px;
      font-size: 14px;
      font-weight: 600;
      font-style: normal;
      font-stretch: normal;
      line-height: 24px;
      letter-spacing: normal;
      text-align: center;
      color: #666666;
      text-align: center;
    }
    .message-input-content-value-p {
      height: 40px;
      font-size: 40px;
      font-weight: bold;
      font-style: normal;
      font-stretch: normal;
      line-height: 40px;
      letter-spacing: normal;
      text-align: center;
      color: #5077aa;
      text-align: center;
    }
    .item-from {
      width: 230px;
      height: 88px;
      border-radius: 8px;
      background-color: #f5f8fb;
      margin-bottom: 16px;
      margin-right: 40px;
      padding-top: 16px;

      .row-paste {
        border-right: solid 1px #f1f1f1;
        float: right;
        margin-right: -19px;
        height: 105px;
        margin-top: 30px;
      }
      &:last-child {
        margin-bottom: 0px;
        .row-paste {
          height: 0px;
        }
      }

      p {
        margin-left: 32px;
        &:first-child {
          height: 24px;
          margin-top: 8px;
          border: solid 1px;
          font-size: 14px;
          font-weight: 600;
          font-style: normal;
          font-stretch: normal;
          line-height: 24px;
          letter-spacing: normal;
          color: #666666;
        }
        &:last-child {
          height: 40px;
          margin-top: 8px;
          font-size: 40px;
          font-weight: bold;
          font-style: normal;
          font-stretch: normal;
          line-height: 40px;
          letter-spacing: normal;
          color: #333333;
        }
      }
    }
    .line-paste-left {
      width: 19px;
      border-top: solid 1px #f1f1f1;
      position: relative;
      float: left;
      margin-left: -19px;
      margin-top: 30px;
    }
    .line-paste-right {
      width: 21px;
      border-top: solid 1px #f1f1f1;
      position: relative;
      float: right;
      margin-right: -21px;
      margin-top: 30px;
    }
    .row-paste-left {
      border-right: solid 1px #f1f1f1;
      float: left;
      height: 105px;
      margin-left: -19px;
      margin-top: 30px;
    }
    .items-from {
      width: 230px;
      height: 88px;
      border-radius: 8px;
      background-color: #e8faf1;
      margin-bottom: 16px;
      margin-left: 40px;
      padding-top: 16px;

      &:last-child {
        margin-bottom: 0px;
        .row-paste-left {
          height: 0px;
        }
      }
      p {
        margin-left: 32px;
        &:first-child {
          height: 24px;
          font-size: 14px;
          font-weight: 600;
          font-style: normal;
          font-stretch: normal;
          line-height: 24px;
          letter-spacing: normal;
          color: #666666;
        }
        &:last-child {
          height: 40px;
          margin-top: 8px;
          font-size: 40px;
          font-weight: bold;
          font-style: normal;
          font-stretch: normal;
          line-height: 40px;
          letter-spacing: normal;
          color: #333333;
        }
      }
    }
  }
}
.infotype {
  float: left;
  width: 120px;
}
</style>
